import { Box, BoxProps, Text } from '@chakra-ui/react';
import { FC } from 'react';

interface AuthFormHeaderProps extends BoxProps {
  heading?: string;
}

export const AuthFormHeader: FC<AuthFormHeaderProps> = ({
  heading,
  children,
  ...rest
}) => {
  return (
    <Box {...rest}>
      {heading && (
        <Text fontSize="xs" color="textSubdued">
          {heading}
        </Text>
      )}
      <Text
        w="full"
        my={2}
        fontSize="lg"
        fontWeight={500}
        data-testid="primary-message"
      >
        {children}
      </Text>
    </Box>
  );
};
